import React from "react";
import { Field } from "formik";
import PropTypes from "prop-types";
import { createUseStyles } from "react-jss";
import _ from "lodash";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import { commonInputGroupStyles } from "..";
import PaxPickerModal from "../../../MainSearchForm/modals/PaxPickerModal";

const paxPickerFieldStyles = createUseStyles({
  inputGroup: (props) => ({
    height: "100%",
    alignContent: "space-between",
    ...commonInputGroupStyles.inputGroup,
    ..._.get(props, "customStyles.inputGroup", {}),
  }),
  label: (props) => ({
    ...commonInputGroupStyles.label,
    ..._.get(props, "customStyles.label", {}),
  }),
  errorMessage: (props) => ({
    ...commonInputGroupStyles.errorMessage,
    ..._.get(props, "customStyles.errorMessage", {}),
  }),
});
const PaxPickerFieldComponent = ({
  field: { name: fieldName },
  form: { touched, errors },
  ...props
}) => {
  return (
    <React.Fragment>
      <PaxPickerModal {...props} />
      {touched[fieldName] && errors[fieldName] && (
        <div className={props.styles.errorMessage}>{errors[fieldName]}</div>
      )}
    </React.Fragment>
  );
};
PaxPickerFieldComponent.defaultProps = {
  styles: {},
};
PaxPickerFieldComponent.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string,
  }).isRequired,
  form: PropTypes.shape({
    touched: PropTypes.object,
    errors: PropTypes.object,
  }).isRequired,
  styles: PropTypes.shape({
    errorMessage: PropTypes.object,
  }).isRequired,
};
export const PaxPickerField = ({
  name,
  label,
  adults,
  childs,
  children_ages,
  infantsOnLap,
  infantsInSeat,
  customStyles,
  onFormUpdate,
  onCancel,
  product_type,
}) => {
  const classes = paxPickerFieldStyles();

  return (
    <div className={classes.inputGroup}>
      <label className={classes.label}>{label}</label>
      <Field
        name={name}
        adults={adults}
        childs={childs}
        children_ages={children_ages}
        infantsOnLap={infantsOnLap}
        infantsInSeat={infantsInSeat}
        customStyles={customStyles}
        onFormUpdate={onFormUpdate}
        onCancel={onCancel}
        product_type={product_type}
        component={PaxPickerFieldComponent}
      />
    </div>
  );
};
PaxPickerField.defaultProps = {
  label: "",
  children_ages: [],
  customStyles: {},
  product_type: "",
};
PaxPickerField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  adults: PropTypes.number.isRequired,
  childs: PropTypes.number.isRequired,
  children_ages: PropTypes.arrayOf(PropTypes.number),
  infantsOnLap: PropTypes.number.isRequired,
  infantsInSeat: PropTypes.number.isRequired,
  customStyles: PropTypes.object,
  onFormUpdate: PropTypes.func,
  onCancel: PropTypes.func,
  product_type: PropTypes.string,
};
